import React, { Fragment } from 'react';
import { useAbTasty } from 'Components/utils/ab-tasty/abTasty.utils';
const script = {
  __html: `
document.addEventListener('cm_app_mounting', function () {
  if (window.ABTasty && window.ABTasty.rollbackModifications) {
    window.ABTasty.rollbackModifications();
  }
});
document.addEventListener('cm_app_mounted', function () {
  if (window.ABTasty && window.ABTasty.applyModifications) {
    window.ABTasty.applyModifications();
  }
});
`,
};
export const AbTasty = () => {
  const { abTastyScriptUrl, isAbTastyActive } = useAbTasty();

  if (!isAbTastyActive) {
    return null;
  }

  return (
    <Fragment>
      <script key="abtasty-lib" async defer src={abTastyScriptUrl} />
      <script
        key="abtasty-inline-script"
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={script}
      />
    </Fragment>
  );
};
